export const tabs = ["Bot Content", "Bot Scheduling"];
export const conciergeTypes = [
  "Entertainment",
  "Fun",
  "Goals",
  "Inspo",
  "Motivation",
  "Personality",
  "Socialising",
  "Throwback",
  "Unwinding",
  "Wellness",
].sort();


// WEBPACK FOOTER //
// ./src/screens/AutoConcierge/constants/selections.js